import { render } from "./NeedBox.vue?vue&type=template&id=5f0a437b&scoped=true"
import script from "./NeedBox.vue?vue&type=script&lang=js"
export * from "./NeedBox.vue?vue&type=script&lang=js"

import "./NeedBox.vue?vue&type=style&index=0&id=5f0a437b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0a437b"]])

export default __exports__